import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { requestInvoices, updateFiltersInvoices, unloadInvoice } from "../../../data/account/actions/invoices";
import { isEmpty } from "lodash";
import moment from 'moment'
import debounce from 'lodash/debounce';
import { FormHeading } from "../../shared/components/Typograhy";
import ComboBox from "../../shared/components/form/ComboBox";
import SlideInAnimation from "../../shared/components/SlideInAnimation";

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InvoiceItemsList from "./InvoiceItemsList";

export default function Invoices() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { entities, isFetching, filters, reachedEnd } = useSelector(state => state.account.invoices);

  useEffect(() => {
    dispatch(unloadInvoice())
    loadBookings();
    setShow(true);
    return()=>{
      disableScrollHandler();
      dispatch(unloadInvoice());
  }
  }, [])

  const loadBookings = (filters, reset = null) => {
    let promise = dispatch(requestInvoices(reset));
    if(promise){
        promise.then(() => {
            enableScrollHandler()
        });
    }
    return promise;
  }

  const loadMore = () => {
    if (isFetching) {
        return;
    }
    disableScrollHandler();
    let dataFilters = filters.route===null && filters.query ===null && filters.date.from===null ? {} : filters;
    let reset = dataFilters? true : false;
    loadBookings(reset);
  }

  let handleScroll = () => {
    if (isFetching || reachedEnd) {
      return;
    }
    const { scrollHeight, clientHeight } = document.documentElement;
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const trigger = scrollHeight - (scrollTop + clientHeight) < 150;

    if (trigger) {
      loadMore();
    }
  }

  const enableScrollHandler = () => {
    window.addEventListener('scroll', handleScroll);
  }

  const disableScrollHandler = () => {
    window.removeEventListener('scroll', handleScroll);
  }

  const handleMonthChange = (event) => {
    dispatch(updateFiltersInvoices({month: event ? event.id : null}))
  };

  const handleYearChange = (event) => {
    dispatch(updateFiltersInvoices({year: event ? event.title : null}))
  };

  const filteredInvoices = (filters) => {
    dispatch(updateFiltersInvoices(filters));
  }

  const throttledSearch = debounce((e) => {
    filteredInvoices({'query':e.target.value})
  }, 500);

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - 2015 + 1 },
    (_, index) => ({
      id: index,
      title: (currentYear - index).toString(),
    })
  );
  const [ defaultYear, setDefaultYear ] = useState(yearOptions[0]);

  const monthOptions = Array.from(
    {length: 12},
    (val, index)=> ({
      id:index,
      title : moment().set('month', index).format('MMMM')
    })
  )
  
  useEffect(() => {
    dispatch(requestInvoices())
  }, [])
  
  return (
    <div className="container mx-auto p-4">
      <FormHeading 
        title={t("account_button.invoices")} 
        subtitle={t('account_button.subtitle_invoices')}
      />

      <div className="flex flex-col sm:flex-row justify-center my-3 shadow-md rounded-md bg-gray-100">
        <input 
            onChange={(e)=>{throttledSearch(e)}} placeholder={t('account.file_number')} 
            className="flex-1 py-2 px-3 mr-1 mt-1 mb-1 rounded-md bg-gray-100 border-b sm:border-none" maxLength="28"
        />
        <span className="hidden sm:block w-px bg-gray-300 h-[30px] mt-2 mb-1"/>
        <ComboBox
          value={null}
          options={monthOptions == null ? [] : monthOptions}
          clearable={true}
          onChange={handleMonthChange}
          placeholder={t('account_button.select_month')}
          className={"flex-1 w-full sm:border-none border-x-0 border-t-0 border-b border-gray-200 focus:ring-2 focus:ring-[#F97316] rounded-md mr-1 mb-1 bg-gray-100"}
          isLoading={false}
        />
        <span className="hidden sm:block w-px bg-gray-300 h-[30px] mt-2 mb-1"/>
        <ComboBox
          value={defaultYear}
          options={yearOptions == null ? [] : yearOptions}
          clearable={false}
          onChange={handleYearChange}
          placeholder={t('account_button.select_year')}
          className={"flex-1 w-full border-none focus:ring-2 focus:ring-[#F97316] rounded-md mr-1 mb-1 bg-gray-100"}
          isLoading={false}
        />
      </div>

      {!isEmpty(entities.invoices) ? 
      <SlideInAnimation show={show} appear={true}>
        <InvoiceItemsList invoices={entities.invoices} editable={false}  endUser={true} />
      </SlideInAnimation>
      : !isFetching ? <>
        <p>{t('account.no_invoices')}</p>
      </>
      : <></>}

      {isFetching &&
      <div className="h-[50vh] overflow-hidden flex justify-center items-center">
          <FontAwesomeIcon icon={faCircleNotch} className={"h-10 w-10 text-gray-300 self-center"} spin />
          <p className="ml-4 text-lg text-gray-800">{t('shared.loading')}...</p>
      </div>}
    </div>
  )
}